/* eslint eqeqeq: "off" */
import React, { useContext, useState } from 'react';
import Context from '../pages/Context';
import axios from 'axios';
// import moment from "moment";
import selector from '../functions/selector';
// criação dos documentos PDF.
import pdfMake from "pdfmake/build/pdfmake";
import moment from 'moment';
import toast from '../functions/toast';
import masknumber from '../functions/masknumber';
import Filter from './Filter';

function Pagamento() {

  const {
    hospital,
    cliente,
    objpaciente,
    setpagamento, pagamento,
    html,
    setfaturamento,
    setarrayatendimentos, arrayatendimentos,
    agenda,
    selectedespecialista,
    setarrayexames,
    agendaexame,
    pagina,
    settoast,
    objatendimento,
    operadoras, setoperadoras,
    procedimentos, setprocedimentos,
  } = useContext(Context);

  let arrayformaspagamento = [
    {
      forma: 'DINHEIRO',
      lancamentos: 1,
    },
    {
      forma: 'PIX',
      lancamentos: 1,
    },
    {
      forma: 'DÉBITO',
      lancamentos: 1,
    },
    {
      forma: 'CRÉDITO 1X',
      lancamentos: 1,
    },
    {
      forma: 'CRÉDITO 2X',
      lancamentos: 2,
    },
    {
      forma: 'CRÉDITO 3X',
      lancamentos: 3,
    },
    {
      forma: 'CRÉDITO 4X',
      lancamentos: 4,
    },
    {
      forma: 'CRÉDITO 5X',
      lancamentos: 5,
    },
    {
      forma: 'CRÉDITO 6X',
      lancamentos: 6,
    },
  ]

  const loadFaturamentos = () => {
    axios.get(html + 'list_faturamento_clinicas/' + cliente.id_cliente).then((response) => {
      let x = response.data.rows;
      setfaturamento(x);
      console.log(x);
      console.log('LISTA DE FATURAMENTOS CARREGADA');
      if (localStorage.getItem('tela_agendamento') == 'CONSULTAS') {
        console.log('ATUALIZANDO LISTA DE CONSULTAS E HORÁRIOS LIVRES');
        loadModdedAtendimentos();
      } else {
        console.log('ATUALIZANDO LISTA DE PROCEDIMENTOS E HORÁRIOS LIVRES');
        setTimeout(() => {
          montaArrayAgenda(localStorage.getItem('selectdate'));
        }, 2000);
      }
    });
  }

  const [arrayfaturas, setarrayfaturas] = useState([]);
  const formapagamento = () => {
    // lancamentos = quantas vezes um registro de faturamento/pagamento deve ser lançado.
    return (
      <div id={'lista de formas de pagamento'}
        className='scroll'
        style={{
          display: 'flex', flexDirection: 'row', justifyContent: 'center', flexWrap: 'wrap',
          width: 'calc(100% - 20px)', height: 200,
        }}>
        <div className='grid'>
          {arrayformaspagamento.map(item => (
            <div
              className='button'
              style={{ width: 150 }}
              id={'forma_pgto ' + item.forma}
              key={'forma_pgto ' + item.forma}
              onClick={() => {
                selector('lista de formas de pagamento', 'forma_pgto ' + item.forma, 300);
                localStorage.setItem('forma_pagamento', item.forma);
                let valor = document.getElementById("inputValorParticular").value;
                let procedimento = JSON.parse(localStorage.getItem('obj_procedimento')); // obj_procedimento pode receber registro de consulta ou de atendimento/procedimento médico.
                let obj_agendado = JSON.parse(localStorage.getItem('obj_agendado'));
                let localarray = [];
                for (let step = 0; step < item.lancamentos; step++) {
                  let data = moment().add(step, 'month');
                  let obj = {
                    cliente_id: cliente.id_cliente,
                    cliente_nome: cliente.razao_social,
                    atendimento_id: localStorage.getItem('tipo_faturamento') == 'ATENDIMENTO' ? obj_agendado.id_atendimento : null,
                    procedimento_id: localStorage.getItem('tipo_faturamento') == 'PROCEDIMENTO' ? obj_agendado.id : null,
                    data_pagamento: step + 1 == 1 ? data.format('DD/MM/YYYY') : null, // primeira parcela paga à vista.
                    data_vencimento: data.format('DD/MM/YYYY'),
                    parcela: step + 1,
                    forma_pagamento: item.forma,
                    status_pagamento: step + 1 == 1 ? 'PAGO' : 'ABERTO', // passar como parâmetro.
                    valor_pagamento: (parseFloat(valor) / item.lancamentos).toFixed(2),
                    id_operadora: obj_agendado.id_operadora,
                    codigo_operadora: null,
                    codigo_tuss: procedimento.tuss_codigo,
                    nome_tuss: procedimento.tuss_rol_ans_descricao,
                    data_registro: moment().format('DD/MM/YYYY'),
                  }
                  // PENDENTE: adaptar para o agendamento de consultas!
                  localarray.push(obj);
                }
                setarrayfaturas(localarray);
                console.log(localarray);
              }}
            >
              {item.forma}
            </div>
          ))}
        </div>
      </div>
    )
  }

  const gerarfaturamento = (obj) => {
    axios.post(html + 'insert_faturamento_clinicas', obj).then(() => {
      console.log('REGISTRO DE FATURAMENTO RECEBIDO COM SUCESSO');
    });
  }

  const updateAtendimento = (tipo) => {
    var obj = {
      data_inicio: objatendimento.data_inicio,
      data_termino: tipo == 'PARTICULAR' ? moment(objatendimento.data_inicio).add(cliente.tempo_consulta_particular, 'minutes') : moment(objatendimento.data_inicio).add(cliente.tempo_consulta_convenio, 'minutes'),
      problemas: objatendimento.problemas,
      id_paciente: objatendimento.id_paciente,
      id_unidade: 5, // ATENÇÃO: 5 é o ID da unidade ambulatorial.
      nome_paciente: objatendimento.nome_paciente,
      leito: null,
      situacao: 3, // 3 = atendimento ambulatorial (consulta).
      id_cliente: hospital,
      classificacao: null,
      id_profissional: objatendimento.id_profissional,
      convenio_id: objatendimento.convenio_codigo,
      convenio_carteira: objatendimento.convenio_carteira,
      faturamento_codigo_procedimento: tipo,
    };
    axios
      .post(html + "update_atendimento/" + objatendimento.id_atendimento, obj)
      .then(() => {
        console.log('AGENDAMENTO DE CONSULTA ATUALIZADO COM SUCESSO')
      });
  };

  const updateProcedimento = (tipo) => {
    let obj = {
      id_exame: null,
      nome_exame: objatendimento.nome_exame,
      codigo_tuss: objatendimento.codigo_tuss,
      particular: tipo == 'PARTICULAR' ? 1 : 0,
      convenio: tipo == 'PARTICULAR' ? 0 : 1,
      codigo_operadora: objatendimento.codigo_operadora,
      id_paciente: objatendimento.id_paciente,
      nome_paciente: objatendimento.nome_paciente,
      dn_paciente: moment(objatendimento.dn_paciente).format('DD/MM/YYYY'),
      id_profissional_executante: objatendimento.id_profissional_executante,
      nome_profissional_executante: objatendimento.nome_profissional_executante,
      conselho_profissional_executante: objatendimento.conselho_profissional_executante,
      n_conselho_profissional_executante: objatendimento.n_conselho_profissional_executante,
      status: objatendimento.status, // 0 = solicitado, 1 = executado, 2 = cancelado, 3 = desistência.
      laudohtml: objatendimento.laudohtml,
      id_cliente: cliente.id_cliente,
      data_exame: objatendimento.data_exame,
    }
    axios
      .post(html + "update_exames_clinicas/" + objatendimento.id, obj)
      .then(() => {
        console.log('AGENDAMENTO DE PROCEDIMENTO ATUALIZADO COM SUCESSO')
      });
  };

  // ## CRIAÇÃO DE RECIBOS EM PDFMAKE ## //
  // impressão de recibo de pagamento (consulta ou procedimento particular).
  const printFile = () => {
    const docDefinition = {
      pageSize: 'A4',
      pageOrientation: 'portrait',
      pageMargins: [40, 200, 40, 120],
      header: {
        stack: [
          {
            columns: [
              {
                image: cliente.logo,
                width: 75,
                alignment: 'center',
              },
              {
                stack: [
                  { text: cliente.razao_social, alignment: 'left', fontSize: 10, width: 300 },
                  { text: 'ENDEREÇO: ' + cliente.endereco, alignment: 'left', fontSize: 6, width: 300 },
                  { text: 'TELEFONE: ' + cliente.telefone, alignment: 'left', fontSize: 6, width: 300 },
                  { text: 'EMAIL: ' + cliente.email, alignment: 'left', fontSize: 6, width: 300 },
                ],
                width: '*'
              },
              { qr: cliente.qrcode, width: '40%', fit: 75, alignment: 'right', margin: [0, 0, 10, 0] },
            ],
            columnGap: 10,
          },
          {
            "canvas": [{
              "lineColor": "gray",
              "type": "line",
              "x1": 0,
              "y1": 0,
              "x2": 800,
              "y2": 0,
              "lineWidth": 1
            }], margin: [0, 10, 0, 0], alignment: 'center',
          },
        ],
        margin: [40, 40, 40, 40],
      },
      footer: function (currentPage, pageCount) {
        return {
          stack: [
            {
              "canvas": [{
                "lineColor": "gray",
                "type": "line",
                "x1": 0,
                "y1": 0,
                "x2": 800,
                "y2": 0,
                "lineWidth": 1
              }], margin: [0, 10, 0, 0], alignment: 'center',
            },
            {
              columns: [
                {
                  stack: [
                    { text: '________________________________', alignment: 'center', width: 400 },
                    { text: 'DEPARTAMENTO FINANCEIRO', width: '*', alignment: 'center', fontSize: 8 },
                  ], with: '30%',
                },
                { text: 'PÁGINA ' + currentPage.toString() + ' DE ' + pageCount, fontSize: 8 },
                { text: '', width: '*' },
              ],
              margin: [40, 40, 40, 40], alignment: 'center',
            },
          ],
        }
      },
      content: [
        { text: 'RECIBO DE PAGAMENTO', alignment: 'center', fontSize: 14, bold: true, margin: 10 },
        { text: localStorage.getItem('texto_recibo'), fontSize: 10, bold: false },
        { text: '---x---', fontSize: 10, bold: true, color: '#ffffff' },
        { text: 'INFORMAÇÕES DO RECEBEDOR:', fontSize: 10, bold: true },
        { text: 'CNPJ: ' + cliente.cnpj, fontSize: 10, bold: false },
        { text: 'RAZÃO SOCIAL: ' + cliente.razao_social, fontSize: 10, bold: false },
        { text: 'ENDEREÇO: ' + cliente.endereco, fontSize: 10, bold: false },
      ],
    }
    // utilizando a lib pdfmake para gerar o pdf e converter em base64.
    const pdfDocGenerator = pdfMake.createPdf(docDefinition);
    pdfDocGenerator.open();
  }
  const [reciboform, setreciboform] = useState(0);
  function ReciboNomePagador() {
    return (
      <div
        className="fundo"
        style={{ display: reciboform == 1 ? "flex" : "none" }}
        onClick={() => { setreciboform(0) }}
      >
        <div className="janela scroll cor2" onClick={(e) => e.stopPropagation()}>
          <div className='text1'>NOME DO PAGADOR</div>
          <input id="inputNomePagador"
            autoComplete="off"
            placeholder="NOME DO PAGADOR..."
            className="input"
            type="text"
            onFocus={(e) => (e.target.placeholder = "")}
            onBlur={(e) => (e.target.placeholder = "NOME DO PAGADOR...")}
            defaultValue={objpaciente != null ? objpaciente.nome_paciente : ''}
            style={{
              flexDirection: "center",
              justifyContent: "center",
              alignSelf: "center",
              textAlign: "center",
              width: 400,
              padding: 15,
              height: 20,
              minHeight: 20,
              maxHeight: 20,
            }}
          ></input>
          <div className='text1'>DOCUMENTO DO PAGADOR</div>
          <input id="inputDocumentoPagador"
            autoComplete="off"
            placeholder="DOCUMENTO DO PAGADOR..."
            className="input"
            type="text"
            onFocus={(e) => (e.target.placeholder = "")}
            onBlur={(e) => (e.target.placeholder = "DOCUMENTO DO PAGADOR...")}
            defaultValue={objpaciente != null ? objpaciente.tipo_documento + ': ' + objpaciente.numero_documento : ''}
            style={{
              flexDirection: "center",
              justifyContent: "center",
              alignSelf: "center",
              textAlign: "center",
              width: 400,
              padding: 15,
              height: 20,
              minHeight: 20,
              maxHeight: 20,
            }}
          ></input>
          <div className='button green'
            style={{ width: 200 }}
            onClick={() => {
              if (localStorage.getItem('parcelas') < 2) {
                let texto = 'RECEBEMOS DE ' + document.getElementById('inputNomePagador').value.toUpperCase() + ', ' + document.getElementById('inputDocumentoPagador').value + ', A IMPORTÂNCIA DE R$' + localStorage.getItem('valor_total') + ', REFERENTE À REALIZAÇÃO DO EXAME/PROCEDIMENTO ' + localStorage.getItem('procedimento');
                localStorage.setItem('texto_recibo', texto);
              } else {
                let texto = 'PAGAMENTO PARCELADO'
                localStorage.setItem('texto_recibo', texto); // PENDENTE
              }
              printFile();
              setreciboform(0);
            }}
          >
            IMPRIMIR RECIBO
          </div>
        </div>
      </div >
    )
  }

  const loadModdedAtendimentos = () => {
    axios
      .get(html + "list_consultas/" + 5) // 5 corresponde ao id da unidade "AMBULATÓRIO".
      .then((response) => {
        var x = response.data.rows;
        var y = x.filter(item => item.id_unidade == 5 && item.id_cliente == cliente.id_cliente);
        carregaHorarioslivres(y);
      });
  };

  const montaArrayAgenda = (data) => {
    // atualizando lista de exames agendados.
    axios.get(html + 'list_exames_clinicas/' + cliente.id_cliente).then((response) => {
      var x = [];
      x = response.data.rows;
      console.log('MONTANDO AGENDA...');
      console.log(data);
      let localarrayexames = []
      // preenchendo a array com os exames já agendados.
      let arrayexamesdodia = x.filter(item => item.id_cliente == cliente.id_cliente && moment(item.data_exame, 'DD/MM/YYYY - HH:mm').format('DD/MM/YYYY') == data);
      arrayexamesdodia.map(item => {
        let obj = {
          id: item.id,
          nome_exame: item.nome_exame,
          data_exame: item.data_exame,
          id_profisisonal_executante: item.id_profissional_executante,
          nome_profissional_executante: item.nome_profissional_executante,
          conselho: item.n_conselho_profissional_executante,
          id_paciente: item.id_paciente,
          nome_paciente: item.nome_paciente,
          dn_paciente: item.dn_paciente,
          status: item.status,
          codigo_operadora: item.codigo_operadora,
          codigo_tuss: item.codigo_tuss,
          particular: item.particular,
        }
        localarrayexames.push(obj);
        return null;
      });
      console.log('ARRAY EXAMES AGENDADOS DO DIA:');
      console.log(localarrayexames);
      // preenchendo a array com os horários disponíveis para agendamento, excluindo os já agendados.
      let arrayagendadodia = agendaexame.filter(item => item.id_cliente == cliente.id_cliente && item.dia_semana == moment(data, 'DD/MM/YYYY').format('dddd').toUpperCase());
      arrayagendadodia.map(item => {
        if (arrayexamesdodia.filter(valor => moment(valor.data_exame, 'DD/MM/YYYY - HH:mm').format('HH:mm') == item.hora_inicio).length == 0) {
          let obj = {
            id: null,
            nome_exame: item.exame,
            data_exame: data + ' - ' + item.hora_inicio,
            id_profissional_executante: item.id_usuario,
            nome_profissional_executante: item.id_nome_usuario,
            conselho: null,
            nome_paciente: null,
            dn_paciente: null,
          }
          localarrayexames.push(obj);
        }
        console.log('ARRAY COM HORÁRIOS MARCADOS E DISPONÍVEIS DO DIA:');
        console.log(localarrayexames);
        return null;
      })
      setarrayexames(localarrayexames);
    });
  }

  // PENDÊNCIA!
  // se disparado da tela mapa, mudar o filtro de agenda retirando o filtro id.usuario.
  const carregaHorarioslivres = (array) => {
    setarrayatendimentos([]);
    console.log(pagina);
    let selectdate = localStorage.getItem('selectdate');
    if (pagina == 'MAPA DE AGENDAMENTOS') { // carrega horários de todos os médicos registrados para o cliente.
      console.log('AGENDAMENTO VIA MAPA');
      let array_origin = array;
      agenda.filter(item => item.id_cliente == cliente.id_cliente && item.dia_semana == moment(selectdate, 'DD/MM/YYYY').format('dddd').toUpperCase()).map(item => {
        array_origin.push(
          {
            situacao: 'AGENDAMENTO',
            id_profissional: item.id_usuario,
            data_inicio: moment(selectdate + ' - ' + item.hora_inicio, 'DD/MM/YYYY - HH:mm'),
            data_termino: moment(selectdate + ' - ' + item.hora_termino, 'DD/MM/YYYY - HH:mm'),
            faturamento_codigo_procedimento: moment(selectdate + ' - ' + item.hora_termino, 'DD/MM/YYYY - HH:mm').diff(moment(selectdate + ' - ' + item.hora_inicio, 'DD/MM/YYYY - HH:mm'), 'minutes') == cliente.tempo_consulta_convenio ? 'CONVÊNIO' : 'PARTICULAR',
          }
        );
        return null;
      });
      setarrayatendimentos(array_origin);
    } else {
      console.log('AGENDAMENTO VIA CADASTRO');
      let array_origin = arrayatendimentos;
      agenda.filter(item => item.id_usuario == selectedespecialista.id_usuario && item.dia_semana == moment(selectdate, 'DD/MM/YYYY').format('dddd').toUpperCase()).map(item => {
        array_origin.push(
          {
            situacao: 'AGENDAMENTO',
            id_profissional: selectedespecialista.id_usuario,
            data_inicio: moment(selectdate + ' - ' + item.hora_inicio, 'DD/MM/YYYY - HH:mm'),
            data_termino: moment(selectdate + ' - ' + item.hora_termino, 'DD/MM/YYYY - HH:mm'),
            faturamento_codigo_procedimento: moment(selectdate + ' - ' + item.hora_termino, 'DD/MM/YYYY - HH:mm').diff(moment(selectdate + ' - ' + item.hora_inicio, 'DD/MM/YYYY - HH:mm'), 'minutes') == cliente.tempo_consulta_convenio ? 'CONVÊNIO' : 'PARTICULAR',
          }
        );
        return null;
      });
      setarrayatendimentos(array_origin);
    }
  }

  const faturamentoInput = (titulo, defaultvalue, tamanho, orientacao) => {
    return (
      <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', width: tamanho }}>
        <div className='text1' style={{ marginBottom: 0 }}>{titulo}</div>
        <input
          className="input"
          autoComplete="off"
          placeholder={titulo}
          onFocus={(e) => (e.target.placeholder = "")}
          onBlur={(e) => (e.target.placeholder = titulo)}
          type="text"
          id={titulo}
          defaultValue={defaultvalue}
          maxLength={100}
          style={{
            margin: 5,
            width: tamanho - 20,
            minWidth: tamanho - 20,
            maxWidth: tamanho - 20,
            textAlign: orientacao == null ? 'center' : 'left',
          }}
        >
        </input>
      </div>
    )
  }

  const [viewconferedadosfaturamentoconvenio, setviewconferedadosfaturamentoconvenio] = useState(0);
  function ConfereDadosFaturamentoConvenio() {
    let profissional_executante = selectedespecialista;
    if (profissional_executante != null && profissional_executante != undefined) {
      return (
        <div id={'viewdadosfaturamentoconvenio'}
          className="fundo"
          style={{
            display: viewconferedadosfaturamentoconvenio == 1 ? 'flex' : 'none',
          }}
          onClick={() => {
            setviewconferedadosfaturamentoconvenio(0);
          }}
        >
          <div
            className='janela scroll cor2'
            onClick={(e) => e.stopPropagation()}
            style={{ width: '80vw', height: '80vh', justifyContent: 'space-between' }}
          >
            <div className='text3' style={{ margin: 10, marginTop: 20, fontSize: 20 }}>{'DADOS DO PRESTADOR (CLÍNICA)'}</div>
            <div style={{
              display: 'flex', flexDirection: 'row', justifyContent: 'space-between', width: '100%',
            }}>
              {faturamentoInput('CNPJ DO PRESTADOR', cliente.cnpj, 200, null)}
              {faturamentoInput('RAZÃO SOCIAL', cliente.razao_social, '100%', 'left')}
            </div>
            <div style={{
              display: 'flex', flexDirection: 'row', justifyContent: 'space-between', width: '100%',
            }}>
              {faturamentoInput('CNES', cliente.cnes, 200, null)}
              {faturamentoInput('ENDEREÇO', cliente.endereco, '100%', 'left')}
              {faturamentoInput('REGISTRO ANS DA OPERADORA', objpaciente != null ? operadoras.filter(operadora => operadora.id == objpaciente.convenio_codigo).map(operadora => operadora.codigo_prestador) : '', 300, null)}
            </div>
            <div className='text3' style={{ margin: 10, marginTop: 20, fontSize: 20 }}>{'DADOS DO PROFISSIONAL'}</div>
            <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', width: '100%' }}>
              {faturamentoInput('NOME DO MÉDICO', profissional_executante.nome_usuario, '100%', 'left')}
              {faturamentoInput('CONSELHO', profissional_executante.conselho, 100, null)}
              {faturamentoInput('Nº CRM', profissional_executante.n_conselho, 100, null)}
              {faturamentoInput('UF', profissional_executante.uf_conselho, 100, null)}
              {faturamentoInput('CÓDIGO CBO', profissional_executante.codigo_cbo, 200, null)}
            </div>
            <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', width: '100%' }}>
              <div className='text3' style={{ margin: 10, marginTop: 20, fontSize: 20 }}>{'DADOS DO BENEFICIÁRIO (PACIENTE)'}</div>
              <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', width: '100%' }}>
                <div className='button' style={{ alignSelf: 'center', width: 200 }}
                  onClick={() => loadOperadoras()}
                >
                  SELECIONAR OPERADORA
                </div>
                <div style={{ display: 'flex', margin: 5, borderRadius: 5, alignSelf: 'center' }}>
                  <img
                    id="img_operadora"
                    alt=""
                    src={objpaciente != null ? operadoras.filter(operadora => operadora.id == objpaciente.convenio_codigo).map(operadora => operadora.logo_operadora) : ''}
                    style={{
                      height: 100,
                      borderRadius: 5,
                      alignSelf: 'center',
                    }}
                  ></img>
                </div>
              </div>
              <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', width: '100%' }}>
                {faturamentoInput('NOME DA OPERADORA', objpaciente != null ? operadoras.filter(operadora => operadora.id == objpaciente.convenio_codigo).map(operadora => operadora.nome_operadora) : '', '100%', 'left')}
                {faturamentoInput('CÓDIGO DA OPERADORA (ANS)', objpaciente != null ? operadoras.filter(operadora => operadora.id == objpaciente.convenio_codigo).map(operadora => operadora.registro_ans) : '', 250, null)}
              </div>
              <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', width: '100%' }}>
                {faturamentoInput('NOME', objpaciente != null ? objpaciente.nome_paciente : '', '100%', 'left')}
                {faturamentoInput('NÚMERO DA CARTEIRA', objpaciente != null ? objpaciente.convenio_carteira : '', 250, null)}
                {faturamentoInput('CARTÃO NACIONAL DE SAÚDE', objpaciente != null ? objpaciente.cns : '', 250, null)}
              </div>
            </div>
            <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', width: '100%' }}>
              <div className='text3' style={{ margin: 10, marginTop: 20, fontSize: 18 }}>{'DADOS DA GUIA'}</div>
              <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'center', width: '100%' }}>
                {faturamentoInput('Nº INTERNO DA GUIA', Math.floor(Math.random() * 9000000) + 1000000, 250, null)}
                {faturamentoInput('DATA DO ATENDIMENTO', moment(objatendimento.data_inicio).format('DD/MM/YYYY'), 250, null)}
                {faturamentoInput('CARÁTER DO ATENDIMENTO', 'E', 250, null)}
                {faturamentoInput('TIPO DE ATENDIMENTO', '04', 250, null)}
              </div>
            </div>
            <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', width: '100%' }}>
              <div className='text3' style={{ margin: 10, marginTop: 20, fontSize: 18 }}>{'DADOS DO PROCEDIMENTO'}</div>
              <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', width: '100%' }}>
                {faturamentoInput('CÓDIGO TUSS', '10101012', 200, null)}
                {faturamentoInput('DESCRIÇÃO', 'CONSULTA EM CONSULTÓRIO (NO HORÁRIO NORMAL OU PREESTABELECIDO)', '100%', 'left')}
                {faturamentoInput('QUANTIDADE', '01', 200, null)}
                {faturamentoInput('VALOR (R$)', procedimentos != null ? procedimentos.filter(procedimento => procedimento.id_operadora == objatendimento.convenio_id && procedimento.tuss_codigo == '10101012').map(procedimento => procedimento.valor) : '', 200, null)}
              </div>
            </div>
            <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', width: '100%' }}>
              {faturamentoInput('OBSERVAÇÃO', '', '100%')}
            </div>
            <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'center', alignSelf: 'center' }}>
              <div className='button' style={{ width: 200 }}>BAIXAR XML</div>
              <div className='button' style={{ width: 200 }} onClick={() => {
                let obj = {
                  logo: document.getElementById('img_operadora').src,
                  n_guia_prestador: document.getElementById('Nº INTERNO DA GUIA').value,
                  codigo_ans: document.getElementById('CÓDIGO DA OPERADORA (ANS)').value,
                  cnpj_prestador: document.getElementById('CNPJ DO PRESTADOR').value,
                  razao_social: document.getElementById('RAZÃO SOCIAL').value,
                  n_carteira: document.getElementById('NÚMERO DA CARTEIRA').value,
                  nome_beneficiario: document.getElementById('NOME').value,
                  cns: document.getElementById('CARTÃO NACIONAL DE SAÚDE').value,
                  codigo_na_operadora: document.getElementById("REGISTRO ANS DA OPERADORA").value,
                  cnes: document.getElementById("CNES").value,
                  profissional_executante: document.getElementById("NOME DO MÉDICO").value,
                  conselho: document.getElementById("CONSELHO").value,
                  n_conselho: document.getElementById("Nº CRM").value,
                  uf: document.getElementById("UF").value,
                  cbo: document.getElementById("CÓDIGO CBO").value,
                  tipo_atendimento: document.getElementById("TIPO DE ATENDIMENTO").value,
                  valor: document.getElementById("VALOR (R$)").value,
                  observacao: document.getElementById("OBSERVAÇÃO").value,
                  codigo_tuss: document.getElementById("CÓDIGO TUSS").value,
                  descricao: document.getElementById("DESCRIÇÃO").value,
                }
                // abrindo a guia SADT em pdf para impressão e salvando-a no formato xml.
                guiaSadtConsulta(obj);
              }}>CONFIRMAR DADOS E FATURAR</div>
            </div>
          </div>
        </div>
      )
    } else {
      return null
    }
  }

  // carregando operadoras/convênios cadastrados no sistema.
  const [arrayoperadoras, setarrayoperadoras] = useState([]);
  const loadOperadoras = () => {
    axios.get(html + 'all_operadoras').then((response) => {
      let x = [];
      x = response.data.rows;
      setoperadoras(x);
      setarrayoperadoras(x);
      setviewoperadoraselector(1);
    })
  };
  // seletor de operadora de saúde/convênio, para faturamento de consulta.
  const [viewoperadoraselector, setviewoperadoraselector] = useState(0);
  function FormOperadoraSelector() {
    return (
      <div className="fundo"
        style={{
          display: viewoperadoraselector == 1 ? 'flex' : 'none',
          flexDirection: 'column', justifyContent: 'center'
        }}
        onClick={() => setviewoperadoraselector(0)}
      >
        <div className="janela scroll cor2"
          style={{ height: '90vh', width: '40vw' }}
          onClick={(e) => e.stopPropagation()}
        >
          {Filter('filtrar_operadora_faturamento', setarrayoperadoras, operadoras, 'item.nome_operadora')}
          {arrayoperadoras.map(item => (
            <div
              key={'operadora: ' + item.nome_operadora}
              className="button"
              style={{ width: 'calc(100% - 20px)', padding: 10, display: 'flex', flexDirection: 'row', justifyContent: 'flex-start' }}
              onClick={() => {
                // alterar código da operadora e código da prestadora junto à operadora.
                console.log(item.registro_ans);
                setviewoperadoraselector(0);
                setTimeout(() => {
                  document.getElementById("CÓDIGO DA OPERADORA (ANS)").value = item.registro_ans;
                  document.getElementById("REGISTRO ANS DA OPERADORA").value = item.codigo_prestador; // código do prestador (clínica) junto à operadora.
                  document.getElementById("NOME DA OPERADORA").value = item.nome_operadora;
                  document.getElementById("img_operadora").src = item.logo_operadora;
                  document.getElementById("VALOR (R$)").value = procedimentos.filter(procedimento => procedimento.id_operadora == item.id && procedimento.tuss_codigo == '10101012').map(procedimento => procedimento.valor);
                }, 200);
              }}>
              <div>{item.nome_operadora}</div>
            </div>
          ))}
        </div>
      </div >
    )
  }

  // cadastro de procedimentos.

  const loadProcedimentos = () => {
    axios.get(html + 'all_procedimentos').then((response) => {
      setprocedimentos(response.data.rows);
      console.log(response.data.rows);
    })
  };

  let pdf_guiasadt = '';
  const guiaSadtConsulta = (obj) => {
    // criando e salvando pdf da guia de consulta SADT.
    const inputPdf = (titulo, valor, tamanho) => {
      return (
        {
          table: {
            widths: ['*'],
            body: [
              [{
                stack: [
                  { text: titulo, fontSize: 8, bold: true },
                  { text: valor, fontSize: 10 }
                ],
              }]
            ]
          },
        }
      )
    }
    const docDefinition = {
      pageSize: 'A4',
      pageOrientation: 'landscape',
      pageMargins: [10, 10, 10, 10],
      content: [
        {
          table: {
            widths: [200, '*', 'auto'],
            body: [
              [
                { image: obj.logo, width: 200 },
                { text: 'GUIA DE SERVIÇO PROFISSIONAL / SERVIÇO AUXILIAR DE DIAGNÓSTICO E TERAPIA - SP/SADT', fontSize: 12, bold: true, margin: 10, width: '*', alignment: 'center' },
                inputPdf('2. Nº DA GUIA NO PRESTADOR', obj.n_guia_prestador, 'auto'),
              ]
            ]
          }, layout: 'noBorders'
        },
        {
          table: {
            widths: ['auto', 'auto'],
            body: [
              [
                inputPdf('1. REGISTRO ANS', obj.codigo_ans, 'auto'),
                inputPdf('3. NÚMERO DA GUIA ATRIBUÍDO PELA OPERADORA', '|__|__|__|__|__|__|__|__|__|__|__|__|__|__|__|__|__|__|__|__|', 'auto'),
              ],
            ]
          }, layout: 'noBorders'
        },
        {
          table: {
            widths: ['*'],
            body: [
              [{ text: 'DADOS DO BENEFICIÁRIO', alignment: 'left', fontSize: 8 }],
            ]
          },
        },
        {
          table: {
            widths: ['auto', 'auto', 'auto'],
            body: [
              [
                inputPdf('4. NÚMERO DA CARTEIRA', obj.n_carteira, 'auto'),
                inputPdf('5. VALIDADE DA CARTEIRA', '|__|__|/|__|__|/|__|__|__|__|', 'auto'),
                inputPdf('6. ATENDIMENTO A RN', '|__|', 'auto'),
              ],
            ]
          }, layout: 'noBorders'
        },
        {
          table: {
            widths: ['*', 'auto'],
            body: [
              [
                inputPdf('7. NOME', obj.nome_beneficiario, '*'),
                inputPdf('8. CARTÃO NACIONAL DE SAÚDE', obj.cns, 'auto'),
              ],
            ]
          }, layout: 'noBorders'
        },
        {
          table: {
            widths: ['*'],
            body: [
              [{ text: 'DADOS DO CONTRATADO', alignment: 'left', fontSize: 8 }],
            ]
          },
        },
        {
          table: {
            widths: ['auto', '*', 'auto'],
            body: [
              [
                inputPdf('9. CÓDIGO NA OPERADORA', obj.codigo_na_operadora, 'auto'),
                inputPdf('10. NOME DO CONTRATADO', obj.razao_social, '*'),
                inputPdf('11. CÓDIGO CNES', obj.cnes, 'auto'),
              ],
            ]
          }, layout: 'noBorders'
        },
        {
          table: {
            widths: ['*', 'auto', 'auto', 'auto', 'auto'],
            body: [
              [
                inputPdf('12. NOME DO PROFISSIONAL EXECUTANTE', obj.profissional_executante, '*'),
                inputPdf('13. CONSELHO PROFISSIONAL', obj.conselho, 'auto'),
                inputPdf('14. NÚMERO NO CONSELHO', obj.n_conselho, 'auto'),
                inputPdf('15. UF', obj.uf, 'auto'),
                inputPdf('16. CÓDIGO CBO', obj.cbo, 'auto'),
              ],
            ]
          }, layout: 'noBorders'
        },
        {
          table: {
            widths: ['*'],
            body: [
              [{ text: 'DADOS DO ATENDIMENTO / PROCEDIMENTO REALIZADO', alignment: 'left', fontSize: 8 }],
            ]
          },
        },
        {
          table: {
            widths: ['auto'],
            body: [
              [
                inputPdf('17. INDICAÇÃO DE ACIDENTE/(acidente ou doença relacionada)', obj.profissional_executante, 'auto'),
              ],
            ]
          }, layout: 'noBorders'
        },
        {
          table: {
            widths: ['auto', 'auto', 'auto', 'auto', 'auto'],
            body: [
              [
                inputPdf('18. DATA DO ATENDIMENTO', moment().format('DD/MM/YYYY'), 'auto'),
                inputPdf('19. TIPO DE CONSULTA', obj.tipo_atendimento, 'auto'),
                inputPdf('20. TABELA', '|__|__|', 'auto'),
                inputPdf('21. CÓDIGO DO PROCEDIMENTO', '10101012', 'auto'),
                inputPdf('22. VALOR DO PROCEDIMENTO', obj.valor, 'auto'),
              ],
            ]
          }, layout: 'noBorders'
        },
        {
          table: {
            widths: ['*'],
            heights: [60],
            body: [
              [
                {
                  table: {
                    widths: ['*'],
                    body: [
                      [{
                        stack: [
                          { text: '23. OBSERVAÇÃO / JUSTIFICATIVA', fontSize: 8, bold: true },
                          { text: obj.observacao, fontSize: 10 }
                        ],
                      }]
                    ]
                  }, layout: 'noBorders'
                }
              ],
            ]
          },
        },
        {
          table: {
            widths: ['*', '*'],
            body: [
              [
                inputPdf('24. ASSINATURA DO PROFISSIONAL EXECUTANTE', '', '*'),
                inputPdf('25. ASSINATURA DO BENEFICIÁRIO OU RESPONSÁVEL', '', '*'),
              ],
            ]
          }, layout: 'noBorders'
        },
      ],
    }
    const pdfDocGenerator = pdfMake.createPdf(docDefinition);
    pdfDocGenerator.open();
    pdfDocGenerator.getBase64(data => {
      pdf_guiasadt = 'data:application/pdf;base64,' + data;
      localStorage.setItem('pdf_guiasadt', pdf_guiasadt);
    })
    // salvando o registro de faturamento, já com o base64 (pdf da guia) e o xml pronto.
    salvaRegistroFaturamento(obj);
  }

  const geraXml = (obj) => {
    console.log(obj);
    const xml =
      `<? xml version = "1.0" encoding = "UTF-8" ?>
          <ansTISS xmlns="http://www.ans.gov.br/padroes/tiss/schemas">
            <cabecalho>
              <identificacaoTransacao>
                <tipoTransacao>ENVIO_LOTE_GUIAS</tipoTransacao>
                <sequencialTransacao>1</sequencialTransacao>
                <dataRegistroTransacao>${moment().format('YYYY-MM-DD')}</dataRegistroTransacao>
                <horaRegistroTransacao>${moment().format('HH:MM:SS')}</horaRegistroTransacao>
              </identificacaoTransacao>
              <origem>
                <identificacaoPrestador>
                  <cpfContratado>${obj.cnpj_prestador}</cpfContratado>
                </identificacaoPrestador>
              </origem>
              <destino>
                <registroANS>${obj.codigo_ans}</registroANS>
              </destino>
              <versaoPadrao>4.01.00</versaoPadrao>
            </cabecalho>
            <prestadorParaOperadora>
              <loteGuias>
                <numeroLote>${moment().format('DDMMYYYY')}</numeroLote>
                <guiasTISS>
                  <guiaSADT>
                    <cabecalhoGuia>
                      <registroANS>${obj.codigo_ans}</registroANS>
                      <numeroGuiaPrestador>${obj.n_guia_prestador}</numeroGuiaPrestador>
                    </cabecalhoGuia>
                    <dadosBeneficiario>
                      <numeroCarteira>${obj.convenio_carteira}</numeroCarteira>
                      <nomeBeneficiario>${obj.nome_paciente}</nomeBeneficiario>
                    </dadosBeneficiario>
                    <dadosSolicitante>
                      <profissionalSolicitante>
                        <nomeProfissional>${obj.profissional_executante}</nomeProfissional>
                        <conselhoProfissional>${obj.conselho}</conselhoProfissional>
                        <numeroConselhoProfissional>${obj.n_conselho}</numeroConselhoProfissional>
                        <UF>${obj.uf}</UF>
                        <CBOS>${obj.cbo}</CBOS>
                      </profissionalSolicitante>
                    </dadosSolicitante>
                    <dadosAtendimento>
                      <dataAtendimento>${moment(objatendimento.data_inicio).format('YYYY-MM-DD')}</dataAtendimento>
                      <horaInicio>${moment(objatendimento.data_inicio).format('HH:MM:SS')}</horaInicio>
                      <horaFim>${moment(objatendimento.data_termino).format('HH:MM:SS')}</horaFim>
                      <caraterAtendimento>E</caraterAtendimento>
                      <tipoAtendimento>04</tipoAtendimento>
                    </dadosAtendimento>
                    <procedimentosExecutados>
                      <procedimentoExecutado>
                        <procedimento>
                          <codigoTabela>22</codigoTabela>
                          <codigoProcedimento>${obj.codigo_tuss}</codigoProcedimento>
                          <descricaoProcedimento>${obj.descricao}</descricaoProcedimento>
                        </procedimento>
                        <quantidadeExecutada>1</quantidadeExecutada>
                        <valorUnitario>${obj.valor}</valorUnitario>
                        <valorTotal>${obj.valor}</valorTotal>
                      </procedimentoExecutado>
                    </procedimentosExecutados>
                    <valorTotal>
                      <valorProcedimentos>${obj.valor}</valorProcedimentos>
                      <valorTotalGeral>${obj.valor}</valorTotalGeral>
                    </valorTotal>
                  </guiaSADT>
                </guiasTISS>
              </loteGuias>
            </prestadorParaOperadora>
            <epilogo>
              <hash>ABC123</hash>
            </epilogo>
          </ansTISS>`;
    downloadXml(xml);
    return xml;
  }

  const downloadXml = (xml) => {
    const blob = new Blob([xml], { type: 'text/xml' });
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = 'guia.xml';
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    URL.revokeObjectURL(url);
  }

  const salvaRegistroFaturamento = (pdf) => {
    let objprocedimento = JSON.parse(localStorage.getItem('obj_procedimento'));
    let objagendado = JSON.parse(localStorage.getItem('obj_agendado'));
    let operadora_id = operadoras.filter(operadora => operadora.registro_ans == pdf.codigo_ans).map(operadora => operadora.id);

    let xml = geraXml(pdf);

    let obj = {
      cliente_id: cliente.id_cliente,
      cliente_nome: cliente.razao_social,
      atendimento_id: localStorage.getItem('tipo_faturamento') == 'ATENDIMENTO' ? objagendado.id_atendimento : null,
      procedimento_id: localStorage.getItem('tipo_faturamento') == 'PROCEDIMENTO' ? objagendado.id : null,
      data_pagamento: moment().format('DD/MM/YYYY'),
      data_vencimento: moment().format('DD/MM/YYYY'),
      parcela: 1,
      forma_pagamento: 'CONVÊNIO',
      status_pagamento: 'ABERTO',
      valor_pagamento: pdf.valor,
      id_operadora: operadora_id,
      codigo_operadora: pdf.codigo_ans,
      codigo_tuss: objprocedimento.tuss_codigo,
      nome_tuss: objprocedimento.tuss_rol_ans_descricao,
      data_registro: moment().format('DD/MM/YYYY'),
      xml: xml,
      guia_pdf: localStorage.getItem('pdf_guiasadt'),
      // PENDÊNCIA! inserir pdf guia sadt aqui!
    }
    gerarfaturamento(obj);
    if (localStorage.getItem('tela_agendamento') == 'CONSULTAS') {
      updateAtendimento('CONVÊNIO');
    } else {
      updateProcedimento('CONVÊNIO');
    }
    setTimeout(() => {
      loadFaturamentos();
    }, 1000);
  }

  return (
    <div
      className="fundo"
      style={{ display: pagamento == 1 ? "flex" : "none" }}
      onClick={() => {
        setpagamento(0);
        var botoes = document
          .getElementById('lista de formas de pagamento')
          .getElementsByClassName("button-selected");
        for (var i = 0; i < botoes.length; i++) {
          botoes.item(i).className = "button";
        }
      }}
    >
      <div className="janela scroll cor2" style={{ height: '80vh' }}
        onClick={(e) => e.stopPropagation()}
      >
        <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
          <div className='button cor1'
            style={{ flexDirection: 'column', justifyContent: 'flex-start' }}>
            <div style={{ padding: 20, fontSize: 20 }}>PARTICULAR</div>
            <div style={{ opacity: 0.6 }}>{'VALOR (R$)'}</div>
            <input id="inputValorParticular"
              autoComplete="off"
              placeholder="VALOR PART..."
              className="input"
              type="text"
              onFocus={(e) => (e.target.placeholder = "")}
              onBlur={(e) => (e.target.placeholder = "VALOR PART...")}
              onKeyUp={() => masknumber(1000, 'inputValorParticular', 200)}
              style={{
                flexDirection: "center",
                justifyContent: "center",
                alignSelf: "center",
                textAlign: "center",
                width: 200,
                padding: 15,
                height: 20,
                minHeight: 20,
                maxHeight: 20,
              }}
            ></input>
            <div style={{ opacity: 0.6, marginTop: 10, marginBlock: 5 }}>{'FORMA DE PAGAMENTO'}</div>
            <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'center', flexWrap: 'wrap' }}>
              {formapagamento(localStorage.getItem('situacao'))}
            </div>
            <div style={{ opacity: 0.6, marginTop: 10 }}>{'EMISSÕES PARA O CLIENTE'}</div>
            <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'center', margin: 10, marginTop: 0 }}>
              <div className='button'
                onClick={() => {
                  localStorage.setItem('valor_total', document.getElementById('inputValorParticular').value);
                  setreciboform(1);
                }}
                style={{ width: 200 }}>
                RECIBO
              </div>
              <div className='button' style={{ width: 200, display: 'none' }}>NFE</div>
              <div
                className='button'
                style={{
                  display: 'flex',
                  width: 200,
                }}
                onClick={() => {
                  if (document.getElementById('inputValorParticular').value != '') {
                    if (localStorage.getItem('forma_pagamento') != 'indefinida') {
                      localStorage.setItem('valor_total', document.getElementById('inputValorParticular').value);
                      console.log(localStorage.getItem('valor_total'));
                      setpagamento(0);
                      var botoes = document
                        .getElementById('lista de formas de pagamento')
                        .getElementsByClassName("button-selected");
                      for (var i = 0; i < botoes.length; i++) {
                        botoes.item(i).className = "button";
                      }

                      if (localStorage.getItem('tela_agendamento') == 'CONSULTAS') {
                        updateAtendimento('PARTICULAR');
                      } else {
                        updateProcedimento('PARTICULAR');
                      }

                      arrayfaturas.map(item => gerarfaturamento(item));
                      setTimeout(() => {
                        loadFaturamentos();
                      }, 1000);

                    } else {
                      toast(
                        settoast,
                        "INDIQUE A FORMA DE PAGAMENTO",
                        "#EC7063",
                        1000
                      );
                    }
                  } else {
                    toast(
                      settoast,
                      "PREENCHA O VALOR",
                      "#EC7063",
                      1000
                    );
                  }
                }}
              >
                CONCLUIR FATURAMENTO
              </div>
            </div>
          </div>
          <div className='button cor1'
            style={{ flexDirection: 'column', justifyContent: 'flex-start' }}>
            <div style={{ padding: 20, paddingBottom: 5, fontSize: 20 }}>CONVÊNIO</div>
            <div style={{ display: 'none', marginTop: 0, color: '#52be80' }}>{objpaciente != null ? objpaciente.convenio_nome : ''}</div>
            <div style={{ display: 'none', marginTop: 20, opacity: 0.6 }}>{'VALOR (R$)'}</div>
            <input id="inputValorConvenio"
              autoComplete="off"
              placeholder="VALOR CONV..."
              className="input"
              type="text"
              onFocus={(e) => (e.target.placeholder = "")}
              onBlur={(e) => (e.target.placeholder = "VALOR CONV...")}
              onKeyUp={() => masknumber(1000, 'inputValorConvenio', 200)}
              style={{
                display: 'none',
                flexDirection: "center",
                justifyContent: "center",
                alignSelf: "center",
                textAlign: "center",
                width: 200,
                padding: 15,
                height: 20,
                minHeight: 20,
                maxHeight: 20,
              }}
            ></input>
            <div style={{ display: 'flex', flexDirection: 'row' }}>
              <div className='button'
                style={{ display: 'flex', width: 200 }}
                onClick={() => {
                  console.log(selectedespecialista);
                  setviewconferedadosfaturamentoconvenio(1);
                  loadProcedimentos();
                }}
              >
                GERAR XML E GUIA SADT
              </div>
              <div
                className='button' style={{ width: 200 }}
                onClick={() => {
                  if (document.getElementById('inputValorConvenio').value != '') {
                    localStorage.setItem('valor_total', document.getElementById('inputValorConvenio').value);
                    setpagamento(0);
                    let objprocedimento = JSON.parse(localStorage.getItem('obj_procedimento'));
                    let objagendado = JSON.parse(localStorage.getItem('obj_agendado'));
                    let obj = {
                      cliente_id: cliente.id_cliente,
                      cliente_nome: cliente.razao_social,
                      atendimento_id: localStorage.getItem('tipo_faturamento') == 'ATENDIMENTO' ? objagendado.id_atendimento : null,
                      procedimento_id: localStorage.getItem('tipo_faturamento') == 'PROCEDIMENTO' ? objagendado.id : null,
                      data_pagamento: moment().format('DD/MM/YYYY'),
                      data_vencimento: moment().format('DD/MM/YYYY'),
                      parcela: 1,
                      forma_pagamento: 'CONVÊNIO',
                      status_pagamento: 'ABERTO',
                      valor_pagamento: parseFloat(localStorage.getItem('valor_total')).toFixed(2), // aqui...
                      id_operadora: objprocedimento.id_operadora,
                      codigo_operadora: null,
                      codigo_tuss: objprocedimento.tuss_codigo,
                      nome_tuss: objprocedimento.tuss_rol_ans_descricao,
                      data_registro: moment().format('DD/MM/YYYY'),
                    }
                    gerarfaturamento(obj);
                    if (localStorage.getItem('tela_agendamento') == 'CONSULTAS') {
                      updateAtendimento('CONVÊNIO');
                    } else {
                      updateProcedimento('CONVÊNIO');
                    }
                    setTimeout(() => {
                      loadFaturamentos();
                    }, 1000);
                  } else {
                    toast(
                      settoast,
                      "PREENCHA O VALOR",
                      "#EC7063",
                      1000
                    );
                  }
                }}
              >
                CONCLUIR FATURAMENTO
              </div>
            </div>
          </div>
        </div>
      </div>
      <ReciboNomePagador></ReciboNomePagador>
      <ConfereDadosFaturamentoConvenio></ConfereDadosFaturamentoConvenio>
      <FormOperadoraSelector></FormOperadoraSelector>
    </div>
  )
}

export default Pagamento;
